import React from 'react';
import './contact.css';

const Contact = () => {
  const handleWhatsappClick = () => {
    const phoneNumber = 9005011100365;
    const message = encodeURIComponent('Merhaba, yardım almak istiyorum.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <div className="contact-page">
        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1551.6557987310134!2d41.25739418225742!3d39.90139958247436!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406e5f1cf925a879%3A0x2b40ef081b2bf004!2sLojmanlar%20Site%20Y%C3%B6netimi!5e1!3m2!1str!2str!4v1739365693840!5m2!1str!2str"
            width="100%"

            title='map'
            height="400"
            style={{ border: '0', backgroundColor: '#000' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="contact-container">
          <div className="contact-header">
            <h2>Bize Ulaşın</h2>
            <p>
              Sorularınızı, önerilerinizi ya da destek taleplerinizi bizimle paylaşın.
              Teknik ekibimiz size en kısa sürede yardımcı olacaktır.
            </p>
          </div>

          <div className="contact-main">
            <div className="contact-wp-btn">
              <button onClick={handleWhatsappClick}>WhatsApp'tan Ulaş</button>
            </div>

            <div className="contact-cards">
              <div className="contact-card">
                <h3>Adresimiz</h3>
                <p>
                  Atatürk Üniversitesi <br />
                  Atatürk Üniversitesi Lojman Site Yönetim Kurulu Başkanlığı, Üniversite Lojmanları YÖK Lojmanları B Blok Yakutiye Erzurum
                </p>
              </div>
              <div className="contact-card">
                <h3>Çalışma Saatlerimiz</h3>
                <p>Hafta içi. 8.00-16.30</p>
                <p>Hafta sonu-Cumartesi 8.30-13.00</p>
              </div>
              <div className="contact-card">
                <h3>İletişim</h3>
                <p>Telefon: +501 110 03 65</p>
                <p>E-posta: ataunilojmanlari@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
